import React, { useEffect, useState } from 'react';
import useNavModel, { RouterParamType } from '@/model/navModel';
import { UserOutlined } from '@ant-design/icons';
import { Avatar, Button, Pagination, Rate, Spin } from 'antd';
import { TablePaginationConfig } from 'antd/lib/table';
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants';
import { ISearchPage } from '@/types/AppTypes';
import { transPgToPagination } from '@/model/globalModel';
import { evaluateService } from '@/views/food/evaluate/evaluateService';
import moment from 'moment';
import { libraryService } from '../../library/libraryService';
import { ILibraryDetial } from '../../library/libraryTypes';

export const Evaluate = () => {
    const { replaceNav, getSelectedNavState } = useNavModel(() => []);
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const initPgCfg: TablePaginationConfig = { pageSize: 5, current: 1 }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const [loading, setLoading] = useState<any>({ spinning: false, tip: "数据加载中..." });
    const [dataSource, setDataSource] = useState<any[]>([]);
    const [foodInfo, setFoodInfo] = useState<ILibraryDetial>([]);

    useEffect(() => {
        detailsInfo && loadData()
    }, [detailsInfo])

    //列表查询
    const loadData = async (
        page: ISearchPage = initPgCfg,
    ) => {
        setLoading({ spinning: true, tip: "数据加载中..." });
        let { retData: food } = await libraryService.one(detailsInfo.id);
        setFoodInfo(food);
        const searchParams = {
            foodId: detailsInfo.id,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await evaluateService.page(searchParams);
        let { data, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(data)
        setLoading({ spinning: false })
    };

    return (
        <Spin {...loading}>
            <div className='remark-container'>
                <div className="remark-head">
                    <div className='head-wrap'>
                        <div className="food-box">
                            <img className="food-img" src={`http://file-server.laoniuche.cn/file/fetch?id=${foodInfo.image}`} alt="" />
                            <ul className="food-info">
                                <li className='info1'>{foodInfo.name + '(份)'}</li>
                                <li className='info2'>口感：{foodInfo.labelName}</li>
                                <li className='info3'>{foodInfo.price ? `￥${foodInfo.price}` : ""}</li>
                            </ul>
                        </div>
                    </div>
                    <Button
                        className="mr-5"
                        type="link"
                        shape="round"
                        size="small"
                        style={{ fontSize: "14px" }}
                        onClick={() => { replaceNav("4-1-1", "4-1") }}
                    >返回</Button>
                </div>
                <div className='remark-other'>全部评论&nbsp;&nbsp;{dataSource.length}</div>
                <div className='remark-content' style={{ height: "calc(100% - 216px)" }}>
                    {dataSource && dataSource.map(item => (
                        <div className='remar-item' key={item.id}>
                            <div className='item-avatar'>
                                <Avatar icon={<UserOutlined />} size={38} />
                            </div>
                            <div className='item-detail'>
                                <div className='item-userinfo'>
                                    <span>{item.user?.name}</span>
                                    <span>{moment(item.updateTime).format("YYYY-MM-DD HH:mm:ss")}</span>
                                    <span className='grade-color'>评分+{item.grade}</span>
                                </div>
                                <Rate allowHalf value={item.grade} className="remark-rate" disabled />
                                <div className='item-desc'>
                                    {item.suggest ? <span>{item.suggest}</span> : <span style={{ color: "#999" }}>无评论内容！</span>}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className='remark-pagination'>
                    {dataSource.length > 0 &&
                        <Pagination  {...{
                            ...pgCfg,
                            showTotal: () => `共${pgCfg.total ?? 0}条`,
                            onChange: (pageNum, pageSize) => {
                                loadData({ pageNum, pageSize })
                            }
                        }} />
                    }
                </div>
            </div>
        </Spin>
    );
}

